import { render } from "./BrazilMap.vue?vue&type=template&id=669ceb53&scoped=true"
import script from "./BrazilMap.vue?vue&type=script&lang=js"
export * from "./BrazilMap.vue?vue&type=script&lang=js"

import "./BrazilMap.vue?vue&type=style&index=0&id=669ceb53&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669ceb53"]])

export default __exports__